import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigAPI } from '@models/types/appconfig.d';
import { AppConfigProvider } from '@root/app/app.config.provider';
import { networkCallInterrupt } from '@services/auth/interrupt-idle-on-network-call';
import { OpenIdConnectService } from '@services/auth/open-id-connect.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class TrackLongCallsInterceptor implements HttpInterceptor {
  private count = 0;
  private ENDPOINTS_TO_TRACK: string[];
  private ENDPOINTS_TO_IGNORE: string[];
  private environment: AppConfigAPI;

  constructor(private auth: OpenIdConnectService, private appConfig: AppConfigProvider) {
    this.appConfig.environment.subscribe(env => {
      this.environment = env.API;
      this.ENDPOINTS_TO_TRACK = [
        `${this.environment.CALCAPI}/api/calculation/run`,
        `${this.environment.RESULTSETAPI}/api/save`,
        `${this.environment.DATASETAPI}/api/dataset/Import`,
        `${this.environment.DATASETAPI}/api/dataset/Aggregate`,
        `${this.environment.DATASETAPI}/api/dataset/PollFileImport`,
        `${this.environment.DATASETAPI}/api/dataset/PollAggregationImport`,
      ];

      this.ENDPOINTS_TO_IGNORE = [
        `${this.environment.USERAPI}/api/users/all`,
        `${this.environment.BALANCEAPI}/api/balancesheetdate`,
        `${this.environment.TRACKINGAPI}/api/tracking/balancesheet`,
        `${this.environment.TRACKINGAPI}/api/tracking/balancesheet?userId=${this.auth.userId}`,
        `${this.environment.TRACKINGAPI}/api/tracking/balancesheet/editingusers`,
        `${this.environment.TRACKINGAPI}/api/tracking/balancesheet/lastchange`,
        `${this.environment.TRACKINGAPI}/api/tracking/editingusers/balancesheet`,
        `${this.environment.LOOKUPAPI}/api/lookup/getsetup`,
      ];
    });
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.ENDPOINTS_TO_IGNORE.includes(request.url)) {
      return next.handle(request);
    } else {
      networkCallInterrupt.next();
      this.count++;
      // console.log(`+1 --> We currently have ${this.count} network calls`);
      return next.handle(request).pipe(
        finalize(() => {
          networkCallInterrupt.next();
          this.count--;
          // console.log(`-1 --> We currently have ${this.count} network calls`);
        })
      );
    }
  }
}
